/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateUserDto } from '../models/CreateUserDto';
import type { UpdateUserProfileDto } from '../models/UpdateUserProfileDto';
import type { UserDto } from '../models/UserDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class UsersService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Create new user entity
     * @param requestBody Data for creating a user
     * @returns UserDto The solicitor has been successfully created.
     * @throws ApiError
     */
    public usersControllerSignup(
        requestBody: CreateUserDto,
    ): Observable<UserDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/users/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update current user profile
     * @param requestBody Data for updating the current user profile
     * @returns UserDto User profile updated successfully.
     * @throws ApiError
     */
    public usersControllerUpdateProfile(
        requestBody: UpdateUserProfileDto,
    ): Observable<UserDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/users/me',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Upload profile photo for user
     * @param id
     * @param formData Profile photo file
     * @returns UserDto Profile photo uploaded successfully.
     * @throws ApiError
     */
    public usersControllerUploadProfilePhoto(
        id: string,
        formData: {
            file?: Blob;
        },
    ): Observable<UserDto> {
        return __request(OpenAPI, this.http, {
            method: 'PATCH',
            url: '/api/users/{id}/profile-photo',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
}
